export default {
    '$route': function() {
        const self = this

        self.post = {}
        self.resetFormResult()
    }
}
